
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.625 12.5122H13.0001","stroke":"#10001F","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10.5002 3.34519C10.7213 3.12417 11.021 3 11.3336 3C11.4884 3 11.6416 3.03048 11.7846 3.08971C11.9276 3.14894 12.0575 3.23575 12.167 3.34519C12.2764 3.45463 12.3632 3.58455 12.4224 3.72754C12.4817 3.87053 12.5122 4.02378 12.5122 4.17855C12.5122 4.33332 12.4817 4.48657 12.4224 4.62956C12.3632 4.77255 12.2764 4.90247 12.167 5.01191L5.22229 11.9566L3 12.5122L3.55557 10.2899L10.5002 3.34519Z","stroke":"#10001F","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    